//输入控件
import React, { Component } from 'react';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import tools from '../utils/tools';
import './ActionControl.less'
import debounce from 'lodash/debounce'; // 引入 lodash 中的 debounce 函数



//图标为false时不显示
class ActionControl extends Component {

  //构造函数
  constructor(props, context) {
    super(props, context);
  }

  static contextTypes = {
    controllerEvent: PropTypes.func
  }
  /*================自定义事件====================*/

  render() {
    const { Name, Src, Title } = this.props;
    return (<div data-Name={Name} onClick={this.debouncedOnClick || this.onClick} className='action'>
      <span className={`icon iconfont ${Src}`} />
      {Title && <p className='title'>{Title}</p>}
    </div>);
  }

  componentWillMount() {

    if (this.props.templateItem) {
      const { DebounceTime } = this.props.templateItem; // 假设 templateItem 中有 debounceTime 属性
      if (DebounceTime) {
        this.debouncedOnClick = debounce(this.onClick, DebounceTime);
      }
    }
  }

  @autobind
  onClick(e) {

    tools.preventEvent(e);
    const { DefaultEventOfAction, Name, ExtraActions, position, templateItem } = this.props;
    let param = { "ActionName": Name }
    if (templateItem && templateItem.Param) {
      param = Object.assign(param, templateItem.Param)
    }
    if (DefaultEventOfAction) {
      this.context.controllerEvent(DefaultEventOfAction, {
        fieldName: Name,
        param: param,
        position,
        isAction: true
      });
    }
    if (ExtraActions && ExtraActions.length > 0) {
      ExtraActions.forEach(eventName => {
        this.context.controllerEvent(eventName, {
          fieldName: Name,
          param: param,
          position,
          isAction: true
        });
      })
    }
  }
}
export default ActionControl;
